module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAAAwBAMAAABAsiHYAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAbUExURUdwTNBObK9ii8kAKOV6j8sAKMsAKBoiev///6CeeegAAAAGdFJOUwCBy2S9mdQKb10AAAAvSURBVDjLYwhLIwgMGEYVMXh0EAQCo4oEGNTLCYJRRaOKiFY0mqWIUzRaRBOlCACtJAgenBA/YAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/th.png
// module id = cCXR
// module chunks = 34